<script>
import { layoutComputed } from "@/state/helpers";
import Vertical from "./vertical";
import socketEvents from "@/components/webSocket/socketEvents";

export default {
  components: {
    Vertical,
    socketEvents,
  },
  computed: {
    ...layoutComputed,
  },
  beforeMount() {
    this.initializeClarity();
  },
  methods: {
    initializeClarity() {
      const trackingCode = process.env.VUE_APP_TRACKING_CODE;
      if (!trackingCode) {
        console.warn("Tracking code is missing. Clarity will not be initialized.");
        return;
      }

      (function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
        t = l.createElement(r);
        t.async = 1;
        t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
      })(window, document, "clarity", "script", trackingCode);
    },
  },
};
</script>

<template>
  <div>
    <Vertical v-if="layoutType === 'vertical'" :layout="layoutType">
      <slot />
    </Vertical>

    <socketEvents />
  </div>
</template>
